import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";


const WIDTH_CELL_BUSINESSID = 100;
const WIDTH_CELL_CREATE_AT= 180;
const WIDTH_CELL_ACTION = 120;
const WIDTH_CELL_CONTEXT_NAME = 250;
const WIDTH_CELL_STATUS_NAME = 200;
const BtnAction = styled.span`
  background: #f6f6f6;
  color: #292929;
  margin: 0px 2px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  padding: 10px 10px;
  cursor: pointer;
  &:hover {
    color: #070707;
    background-color: #f1f1f1;
  }
`;

export const getColumsInstance = () => {
  

  const columns = [
    {
      Header: "Business ID",
      accessor: "businessId",
      sortable: false,
      width: WIDTH_CELL_BUSINESSID,
      style: { whiteSpace: "unset", paddingTop: 15 },
    },
    {
      Header: "Fecha/Hora Registro",
      accessor: "creatDate",
      sortable: false,
      width: WIDTH_CELL_CREATE_AT,
      style: { whiteSpace: "unset", paddingTop: 15 },
    },
    {
      Header: "Estado",
      accessor: "statusName",
      sortable: false,
      width: WIDTH_CELL_STATUS_NAME,
      style: { whiteSpace: "unset", paddingTop: 15 },
    },
    {
      Header: "Fecha/Hora Fin",
      accessor: "finishDate",
      sortable: false,
      style: { whiteSpace: "unset", paddingTop: 15 },
    },
    {
      Header: "leadtime",
      accessor: "leadtime",
      sortable: false,
      style: { whiteSpace: "unset", paddingTop: 15 },
    },
    {
      Header: "Contexto",
      accessor: "contextName", 
      sortable: false,
      width: WIDTH_CELL_CONTEXT_NAME,
      style: { whiteSpace: "unset", paddingTop: 15 },
    },
    /* {
      Header: "Acción",
      style: { whiteSpace: "unset", paddingTop: 16, paddingBottom: 14 },
      width: WIDTH_CELL_ACTION,
      sortable: false,
      filterable: false,
      Cell: ({ row }) => (
        <Link to={`/home/detail/${row.businessId}/${row._original.idInstance}`}>
          <BtnAction> Ver Detalle </BtnAction>
        </Link>
      ),
    }, */
  ];

  return columns;
};
export default getColumsInstance;
